/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import AttributeCondition from 'cio/app-models/conditions/attribute';
import EventAttributeCondition from 'cio/app-models/conditions/event-attribute';
import CollectionAttributeCondition from 'cio/app-models/conditions/collection-attribute';
import { OperatorGroupDropdownItem } from 'cio/components/condition-editor/attribute';

interface ConditionEditorAttributeOperatorArgs {
  condition: AttributeCondition | EventAttributeCondition | CollectionAttributeCondition;
  disabled?: boolean;
  operatorGroups: OperatorGroupDropdownItem[];
  onOperatorSelect: (operator: string) => unknown;
  size?: string;
  selectedOperatorDropdownOption: string;
  hasError?: boolean;
  errorMessage?: string;
}

export default class ConditionEditorAttributeOperator extends Component<ConditionEditorAttributeOperatorArgs> {
  get hasOnlyOneGroup() {
    return (this.args.operatorGroups ?? []).length === 1;
  }

  get selectItems() {
    if ((this.args.operatorGroups ?? []).length === 1) {
      return this.args.operatorGroups[0].items;
    }

    return this.args.operatorGroups;
  }
}
